import type React from "react";
import { UnauthorizedState } from "../components/feedback/UnauthorizedState";
import { LinkExpiredState } from "../components/feedback/LinkExpiredState";
import { i18n } from "@frontend/i18n";
import { useOtpAuthController } from "../controllers/useOtpAuthController";

export function OtpAuthPage(): React.JSX.Element {
  const { state } = useOtpAuthController();

  if (state.errorMessage !== null) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        data-testid="otp-auth-error"
      >
        {state.isExpired ? (
          <LinkExpiredState message={state.errorMessage} />
        ) : (
          <UnauthorizedState message={state.errorMessage} />
        )}
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      data-testid={`otp-auth-${state.isSuccess ? "success" : "verifying"}`}
    >
      <div className="flex flex-col items-center gap-3">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary"
          role="status"
          aria-label="Authenticating"
        />
        <span className="text-sm text-muted-foreground">
          {i18n.t("auth.otp.title.authenticating")}
        </span>
      </div>
    </div>
  );
}
